import { z } from 'zod';

export interface ApiRequestParams {
    query?: Record<string, any>,
    segments?: Record<string, string | number>,
    requestBody?: Record<string, any> | FormData,
}

export interface Endpoint {
    name: string,
    method: 'get' | 'post' | 'put' | 'patch' | 'delete',
    path: string,
}

export interface ApiResponse<T = any> {
    data: T,
    status: number,
    message?: string,
}

export type RegisterToken = {
    form_token_field_name: string,
    form_token_field_value: string,
    form_token_valid_after_seconds: number,
};

export const RegisterTokenSchema = z.object({
    form_token_field_name: z.string(),
    form_token_field_value: z.string(),
    form_token_valid_after_seconds: z.number(),
});
